import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/index.less' // global css

Vue.config.productionTip = false

import "vant/lib/index.css"
import vant from "vant";
Vue.use(vant); 

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min'
// import 'bootstrap'

import { myAjax } from '@/api/httpRequest'
Vue.prototype.$myAjax = myAjax;//json请求

import api from '@/api/api.js'
Vue.prototype.$api = api;//

import '@/permission'

import {__setlocalStorage,__getlocalStorage,__removelocalStorage, __clearlocalStorage,judge,GetDateStr} from './utils/utils';
Vue.prototype.$setlocalStorage = __setlocalStorage;
Vue.prototype.$getlocalStorage = __getlocalStorage;
Vue.prototype.$removelocalStorage = __removelocalStorage;
Vue.prototype.$clearlocalStorage = __clearlocalStorage;
Vue.prototype.$judge = judge;
Vue.prototype.$GetDateStr = GetDateStr;

import * as filters from '@/utils/filter/index'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


// 复制文字
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 自定义指令
import install from '@/utils/directive/index'
Vue.use(install)

import Navigation from 'vue-navigation';
Vue.use(Navigation, {router}); // vue-router 实例


// 全局组件注册
// import cNavbar from '@/components/public/navbar'
// import cNoData from '@/components/public/noData'
// import cPopup from '@/components/public/popup'

// 注册为全局组件
// Vue.component('cNavbar', cNavbar)
// Vue.component('cNoData', cNoData)
// Vue.component('cPopup', cPopup)


// import wxsdk from '@/utils/sdk'

// Vue.prototype.$wxsdk = wxsdk;

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'G2Uxpv1N1kO9oQbKqgxM1fI6y9IMXsZu'
})


window.version = '1.1.02'
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
